/* eslint-disable import/prefer-default-export */
export const clearAll = () => ({
  type: 'CLEAR_ALL',
});



// WEBPACK FOOTER //
// ./src/js/vendor/choices/actions/misc.js